import script from "./CommisionSection2.vue?vue&type=script&setup=true&lang=js"
export * from "./CommisionSection2.vue?vue&type=script&setup=true&lang=js"

import "./CommisionSection2.vue?vue&type=style&index=0&id=176d0748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-176d0748"]])

export default __exports__